import * as React from "react";
import posed from "react-pose";
import styled, { css } from "styled-components";
import { select } from "@hubper/theme";

const Base = styled.div<{ scroll?: boolean }>`
  max-width: calc(100% - 20px);
  padding: ${select.space(5)};
  box-sizing: border-box;
  border-radius: ${select.radius("normal")};
  background-color: white;
  transform: translate(-50%, -50%);
  overflow: hidden;
  ${p =>
    p.scroll &&
    css`
      overflow-y: auto;
    `}
`;

type WithModalConfig = {
  width?: any;
  height?: any;
  scroll?: boolean;
  padding?: number;
};

type InnerProps = {
  style?: React.CSSProperties;
  index?: number;
};

function withModal<P extends {}>(
  { width = "auto", height = "auto", padding, scroll }: WithModalConfig,
  Component: React.ComponentType<P>
): React.ComponentType<P & InnerProps> {
  function WithModal({ style, ...rest }: P & InnerProps, ref: any) {
    return (
      <Base
        style={{
          ...style,
          width,
          height,
          padding
        }}
        scroll={scroll}
        ref={ref}
      >
        <Component {...(rest as P)} />
      </Base>
    );
  }

  return posed(React.forwardRef(WithModal) as any)({
    enter: {
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30
      }
    },
    exit: {
      opacity: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30
      }
    }
  }) as any;
}

export default withModal;
